export const ScoreStringComponent = ({ title, description, analyze }) => {
  return (
    <div className="flex flex-col rounded m-4 bg-neutral text-white p-4">
      <h2 className="text-lg mb-2">{title}</h2>
      <span className="badge badge-info h-fit ">{description}</span>
      <p>Analyse: {analyze}</p>
    </div>
  );
};
